module.exports = __webpack_public_path__ + "img/icon-user@3x.dd429e4f.png";